/**
 * Gift Threshold Calculator
 * Handles progressive gift threshold messaging in the cart
 */

// Get currency symbol from Shopify settings
function getCurrencySymbol() {
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
    const currency = window.Shopify.currency.active;
    const symbols = {
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'CAD': 'CA$',
      'AUD': 'A$',
      'JPY': '¥',
      'CNY': '¥',
      'INR': '₹',
      'BRL': 'R$',
      'MXN': 'MX$',
      'SEK': 'kr',
      'NOK': 'kr',
      'DKK': 'kr',
      'CHF': 'CHF',
      'NZD': 'NZ$',
      'SGD': 'S$',
      'HKD': 'HK$',
      'KRW': '₩',
      'RUB': '₽',
      'PLN': 'zł',
      'THB': '฿',
      'TRY': '₺',
      'ZAR': 'R'
    };
    return symbols[currency] || currency + ' ';
  }
  return '$'; // Default fallback
}

window.calculateGiftThreshold = function calculateGiftThreshold(cartSubtotal) {
  const currencySymbol = getCurrencySymbol();
  console.log('calculating gift threshold, cart subtotal:', cartSubtotal);
  const giftThresholds = document.querySelectorAll('.free-gift-threshold');
  
  console.log('Found gift threshold elements:', giftThresholds.length);
  
  if (giftThresholds.length === 0) {
    console.warn('⚠️ No .free-gift-threshold elements found on page. Make sure:');
    console.warn('1. Gift Threshold is enabled in theme settings');
    console.warn('2. Gift threshold amounts and texts are configured');
    return;
  }

  for (const giftThreshold of giftThresholds) {
    const thresholdsStr = giftThreshold.dataset.giftthresholds;
    const textsStr = giftThreshold.dataset.gifttexts;
    
    console.log('Thresholds string:', thresholdsStr);
    console.log('Texts string:', textsStr);

    if (!thresholdsStr || !textsStr) {
      console.log('Missing thresholds or texts data attributes');
      continue;
    }

    // Parse comma-separated values
    const thresholdAmounts = thresholdsStr.split(',').map(t => parseFloat(t.trim())).filter(t => !isNaN(t));
    const thresholdTexts = textsStr.split(',').map(t => t.trim());

    if (thresholdAmounts.length === 0 || thresholdTexts.length === 0) {
      continue;
    }

    const cartAmount = Number.parseFloat(cartSubtotal / 100).toFixed(2);
    const giftCopy = giftThreshold.querySelector('.free-gift-copy');
    
    if (!giftCopy) {
      console.error('❌ .free-gift-copy element not found inside .free-gift-threshold');
      continue;
    }
    
    console.log('Cart amount (formatted):', cartAmount);
    console.log('Threshold amounts:', thresholdAmounts);
    console.log('Threshold texts:', thresholdTexts);

    // Find the appropriate threshold
    let currentThresholdIndex = -1;
    let nextThresholdIndex = -1;

    // Sort thresholds in ascending order
    const sortedIndices = thresholdAmounts
      .map((amount, index) => ({ amount, index }))
      .sort((a, b) => a.amount - b.amount);

    // Determine which thresholds the cart has reached and which is next
    for (let i = 0; i < sortedIndices.length; i++) {
      const { amount, index } = sortedIndices[i];
      if (parseFloat(cartAmount) >= amount) {
        currentThresholdIndex = index;
      } else if (nextThresholdIndex === -1) {
        nextThresholdIndex = index;
        break;
      }
    }

    // Display the message from data-giftTexts
    let displayIndex = -1;
    
    if (nextThresholdIndex >= 0) {
      // Show message for the next threshold to reach
      displayIndex = nextThresholdIndex;
    } else if (currentThresholdIndex >= 0) {
      // Show message for the highest threshold reached
      displayIndex = currentThresholdIndex;
    }

    console.log('Current threshold index:', currentThresholdIndex);
    console.log('Next threshold index:', nextThresholdIndex);
    console.log('Display index:', displayIndex);

    if (displayIndex >= 0 && thresholdTexts[displayIndex]) {
      let message = thresholdTexts[displayIndex];
      console.log('Original message:', message);
      
      // Prepare replacement values
      const currentThresholdAmount = currentThresholdIndex >= 0 ? thresholdAmounts[currentThresholdIndex] : 0;
      const nextThresholdAmount = nextThresholdIndex >= 0 ? thresholdAmounts[nextThresholdIndex] : 0;
      const remainder = nextThresholdIndex >= 0 ? Number.parseFloat(nextThresholdAmount - cartAmount).toFixed(2) : '0';
      
      console.log('Replacement values - current:', currentThresholdAmount, 'next:', nextThresholdAmount, 'remainder:', remainder);
      console.log('Currency symbol:', currencySymbol);
      
      // Replace [[amount]] with remaining amount to next threshold (with currency symbol)
      message = message.replace(/\[\[amount\]\]/g, currencySymbol + remainder);
      
      // Replace [[threshold]] placeholders (with currency symbol)
      // First occurrence = current threshold (if reached), subsequent = next threshold
      let thresholdReplaceCount = 0;
      message = message.replace(/\[\[threshold\]\]/g, () => {
        thresholdReplaceCount++;
        if (thresholdReplaceCount === 1 && currentThresholdIndex >= 0 && nextThresholdIndex >= 0) {
          // First [[threshold]] when between thresholds = current (earned) threshold
          return currencySymbol + currentThresholdAmount.toFixed(2);
        } else {
          // Otherwise use the display threshold (could be current if last, or next if progressing)
          return currencySymbol + thresholdAmounts[displayIndex].toFixed(2);
        }
      });
      
      console.log('Final message:', message);
      giftCopy.innerHTML = message;
      giftThreshold.classList.remove('hidden');
    } else {
      console.log('No valid display index or text');
      giftThreshold.classList.add('hidden');
    }
  }
}

// Fetch and update cart threshold
function fetchAndUpdateCartThreshold() {
  console.log('Fetching cart state...');
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Cart data received:', cart);
      
      // Set currency if available from cart
      if (cart.currency && !window.Shopify) {
        window.Shopify = { currency: { active: cart.currency } };
      } else if (cart.currency && window.Shopify && !window.Shopify.currency) {
        window.Shopify.currency = { active: cart.currency };
      } else if (cart.currency && window.Shopify && window.Shopify.currency) {
        window.Shopify.currency.active = cart.currency;
      }
      
      if (cart && cart.items_subtotal_price !== undefined) {
        console.log('Calling calculateGiftThreshold with:', cart.items_subtotal_price);
        window.calculateGiftThreshold(cart.items_subtotal_price);
      } else {
        console.log('Cart data is missing items_subtotal_price');
      }
    })
    .catch(error => {
      console.error('Could not fetch cart state:', error);
    });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  fetchAndUpdateCartThreshold();

  // Listen for cart drawer opening
  const cartToggles = document.querySelectorAll('.js-sidecart--toggle, .js-cart-icon');
  cartToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      setTimeout(fetchAndUpdateCartThreshold, 100);
    });
  });

  // Watch for cart updates by observing the cart price element
  const observeCartChanges = () => {
    const priceElements = document.querySelectorAll('.js-price');
    
    priceElements.forEach(priceElement => {
      const observer = new MutationObserver((mutations) => {
        fetchAndUpdateCartThreshold();
      });

      observer.observe(priceElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };

  // Start observing after a short delay to ensure elements are loaded
  setTimeout(observeCartChanges, 500);

  // Also listen for body class changes (cart opening/closing)
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        const classList = document.body.classList;
        if (classList.contains('cart--open')) {
          fetchAndUpdateCartThreshold();
        }
      }
    });
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
});

// Listen for Shopify cart events (if any are fired)
document.addEventListener('cart:updated', fetchAndUpdateCartThreshold);
document.addEventListener('cart:refresh', fetchAndUpdateCartThreshold);

// Override Shopify cart update if available
if (window.Shopify && window.Shopify.onCartUpdate) {
  const originalUpdate = window.Shopify.onCartUpdate;
  window.Shopify.onCartUpdate = function() {
    originalUpdate.apply(this, arguments);
    fetchAndUpdateCartThreshold();
  };
}
